import { InnerPageHero } from "../components/InnerPageHero";
import { SponsorSection } from "../components/SponsorSection";

export function SponsorsPage() {
  return (
    <main id="top">
      <InnerPageHero kicker="AIYSS / SPONSORS" title="スポンサー募集" />
      <SponsorSection />
    </main>
  );
}
